import { render, staticRenderFns } from "./editContact.vue?vue&type=template&id=b6640e22&scoped=true"
import script from "./editContact.vue?vue&type=script&lang=js"
export * from "./editContact.vue?vue&type=script&lang=js"
import style0 from "./editContact.vue?vue&type=style&index=0&id=b6640e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6640e22",
  null
  
)

export default component.exports